module.exports = __webpack_public_path__ + "static/media/clock-add.e0238033.svg";